import { Box, Button, CircularProgress, Divider, Grid, MenuItem, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient} from "react-query";
import { DialogProps} from "types";
import { StyledServiceItem, StyledServicesContainer } from "views/services/SubtaskServices/styles";
import SearchContainer from "components/SearchContainer";
import { getDefaultMetaTemplates, sendTemplateMessageWithSelectedTemplate } from "api/services/communication";
import { AxiosResponse } from "axios";
import { snack } from "components/toast";

interface Props extends DialogProps {
    data: any;
    userData: any
}


function TemplateSelection({ open, setOpen, data}: Props) {
    console.log(data,'prop')
    const queryClient = useQueryClient();

    const [search, setSearch] = useState("");
    const [selectedTemplate, setSelectedTemplate] = useState<any>(null);

    
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

   
   
    const { data:templates, isLoading, error } = useQuery<AxiosResponse<any>>(
        'default-templates',
        getDefaultMetaTemplates,
    );
    const { mutate: sendTemplate, isLoading:send } = useMutation(sendTemplateMessageWithSelectedTemplate, {
        onSuccess: () => {
            snack.success(`Template Message Sent Successfully to,${data}`)
            queryClient.invalidateQueries("whatsappConversation");
            // setMessage('');
        },
        onError: (err: any) => {
            console.log('Error sending message:', err);
        },
    });

    useEffect(() => {
        if (!open) {
            setSelectedTemplate(null);
        }
    }, [open]);
    const handleClick = (template: any) => {
        setSelectedTemplate(template); // Set selected template
    };

    return (
        <DialogWrapper
            width="lg"
            open={open}
            setOpen={setOpen}
            title="Template Selection"
        >

            <Box display="flex" flexDirection={isSmallScreen ? 'column' : 'row'} justifyContent="space-between">
                <Box display="flex" justifyContent={isSmallScreen ? 'center' : 'flex-end'} width={isSmallScreen ? '100%' : 'auto'} sx={{gap:"30px"}}>
                    <SearchContainer
                        value={search}
                        debounced
                        minWidth={isSmallScreen ? '100%' : '400px'}
                        onChange={setSearch}
                        placeHolder="Search by Template Name"
                    />
                    <Button
        variant="contained"
        color="primary"
        disabled={!selectedTemplate}
        onClick={() => {
            if (selectedTemplate) {
                sendTemplate({
                    mobileNumber: data,
                    templateName: selectedTemplate.templateName,
                    language: selectedTemplate.language,
                });
                setOpen(false)

            }
        }}
    >
        Send Template
    </Button>
                </Box>
            </Box>

            <Divider sx={{ mt: 2 }} />

           
            <StyledServicesContainer>
                <Grid container spacing={2} padding={2}>
                    {templates?.data?.map((item: any, index: number) => (
                        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                            <StyledServiceItem
                                onClick={() => handleClick(item)}
                                sx={{
                                    padding: 2,
                                    borderRadius: 2,
                                    border: selectedTemplate?.templateName === item.templateName
                                        ? `1px solid ${theme.palette.secondary.main}`
                                        : '1px solid #ccc',
                                    cursor: 'pointer',
                                    backgroundColor: selectedTemplate?.templateName === item.templateName
                                        ? '#f9f9f9'
                                        : '#fff',
                                    transition: 'border 0.3s',
                                }}
                            >
                                <Box width="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                    <Box mb={1}>
                                        <Typography variant="h6" color="rgba(0,0,0,0.6)">
                                                {item.templateName}
                                            </Typography>
                                            <Box display="flex" justifyContent="space-between">

                                            <Typography variant="caption" color="rgba(0,0,0,0.6)">
                                                {item.body}
                                            </Typography>
                                        </Box>
    
                                    </Box>
                                  
                                </Box>
                            </StyledServiceItem>
                        </Grid>
                    ))}
                </Grid>
             
            </StyledServicesContainer>
        </DialogWrapper>
    );
}

export default TemplateSelection;